import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { SocialSalesSourceUpdateInput } from "@/modules/social-sales-sources/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import {
    useSocialSalesSourceQuery,
    useUpdateSocialSalesSourceMutation,
} from "../api/queries";
import { SocialSalesSourceForm } from "../ui/SocialSalesSourceForm";

export function SocialSalesSourceEditPage() {
  const nav = useNavigate({
    from: "/app/settings/social-sales-sources/$id/edit",
  });
  const { id } = useParams({
    from: "/app/settings/social-sales-sources/$id/edit",
  });
  const { data, ...result } = useSocialSalesSourceQuery(id);
  const update = useUpdateSocialSalesSourceMutation(id);
  const row = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແຫຼ່ງຂາຍ Social Media",
              to: "/app/settings/social-sales-sources",
            },
            { label: row?.name ?? "ແກ້ໄຂ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂແຫຼ່ງຂາຍ</h2>
          <Button
            variant="outline"
            onClick={() =>
              nav({ to: "/app/settings/social-sales-sources" } as never)
            }
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!row ? null : (
            <div className="rounded-xl border bg-card p-6">
              <SocialSalesSourceForm
                key={row.id}
                mode="edit"
                initialValues={{
                  code: row.code,
                  name: row.name,
                  sortOrder: row.sortOrder,
                  isActive: row.isActive,
                }}
                submitting={update.isPending}
                onSubmit={async (values) => {
                  await update.mutateAsync(
                    values as SocialSalesSourceUpdateInput,
                  );
                  nav({ to: "/app/settings/social-sales-sources" } as never);
                }}
                onCancel={() =>
                  nav({ to: "/app/settings/social-sales-sources" } as never)
                }
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
